import { render, staticRenderFns } from "./tableApply.vue?vue&type=template&id=55a80dc1&"
import script from "./tableApply.vue?vue&type=script&lang=js&"
export * from "./tableApply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports